module.exports = __webpack_public_path__ + "static/media/inex-logo.eb5bb496.svg";